
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSensorGpsBad as ObiSensorGpsBadElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sensor-gps-bad.js';
 
 
 

 
 export const ObiSensorGpsBad = createComponent({
   react: React,
   tagName: 'obi-sensor-gps-bad',
   elementClass: ObiSensorGpsBadElement,
   events: {
     
   }
  });
 
 